import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Router } from '@angular/router';

@Component({
  selector: 'sl-link',
  standalone: true,
  imports: [],
  templateUrl: './sl-link.component.html',
  styleUrl: './sl-link.component.scss',
})
export class SlLinkComponent {
  @Input({ required: true }) text!: string;
  @Input() icon?: string;
  @Input() fullWidth?: boolean;
  @Input() link!: string;
  @Input() variant: 'link' | 'button' = 'link';
  @Output() actionEvent: EventEmitter<void> = new EventEmitter<void>();

  onKeyUpLink(event: KeyboardEvent) {
    const pressedKey = event.key;

    if (pressedKey === ' ') {
      this.router.navigate([this.link]);
    }
  }

  clickLinkEvent() {
    this.actionEvent.emit();
  }

  constructor(private readonly router: Router) {}
}
